enum ComboStatus {
    //COMPTE0 must be first
    COMPTE0, COMPTE1, COMPTE2, COMPTE3, COMPTE4, COMPTE5,
    COMPTE6, COMPTETOT,
    CLEAR00, CLEAR01, CLEAR02, CLEAR03, CLEAR04, CLEAR05,
    CLEAR06, CLEAR07, CLEAR08, CLEAR09, CLEAR10, CLEAR11,
    CLEAR12, CLEAR13, CLEARMORE,
    DEATH, FRAG, LINESTOT, SCORE,
    LAST_BEFORE_120, //Actual value irrelevent
    //All new 1.2.0 stats must be after LAST_BEFORE_120
    CLEAR14, CLEAR15, CLEAR16, CLEAR17, CLEAR18, CLEAR19, CLEAR20,
    ROTATED0, ROTATED1, ROTATED2, ROTATED3, ROTATED4, ROTATED5,
    ROTATED6, ROTATEDTOT,
    PLAYING_TIME, PPM, BPM, ROUND_WINS,
    SUICIDES, OVERKILLEE, OVERKILLER, MAXOVERKILLEE, MAXOVERKILLER,
    COMBO00, COMBO01, COMBO02, COMBO03, COMBO04, COMBO05,
    COMBO06, COMBO07, COMBO08, COMBO09, COMBO10, COMBO11,
    COMBO12, COMBO13, COMBO14, COMBO15, COMBO16, COMBO17,
    COMBO18, COMBO19, COMBO20,
    LINESCUR,
    //LAST must be last (duh)
    LAST
};

enum GameStatus {
    PLAYING_TIME, ROUND_NUMBER,
    LAST
};

enum CanvasStatus  {
    PLAYING,
    WAITFORWINNER,
    WAITFORRESTART,
    LAST
};

enum KeyStatus {
    NONE,
    PRESSED,
    RELEASED,
}

export { ComboStatus, GameStatus, CanvasStatus, KeyStatus }
